module.exports = __webpack_public_path__ + "static/img/son1.313fc490.png";